// hooks/useWishlist.ts
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { createWishList } from '../service/createWishList';
import showToast from '../components/ToastComponent';

export function useWishlist(
  productId: number | undefined,
  wishListData: any[] | undefined,
  callWishList: () => Promise<void>,
) {
  const { user } = useAuth();
  const [isWishListed, setIsWishListed] = useState(false);

  useEffect(() => {
    setIsWishListed(
      Boolean(wishListData?.find((w) => w?.product?.id === productId)),
    );
  }, [productId, wishListData]);

  const toggleWishlistMutation = useMutation({
    mutationFn: () =>
      createWishList(user?.access_token as string, productId as number),
    onSuccess: (response) => {
      showToast({
        message: response.message,
        type: typeof response.status === 'number' ? 'warning' : 'info',
      });
    },
    onError: (err) => {
      console.log('Error while add/remove wishlist product:', err);
    },
    onSettled: () => {
      callWishList();
    },
  });

  return {
    isWishListed,
    toggleWishlist: toggleWishlistMutation.mutate,
    wishlistLoading: toggleWishlistMutation.isPending,
  };
}
